import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { amber, lightGrey } from 'constants/Colors';

type Level = 'high' | 'medium' | 'low';

// Behovsanställda: 5–7 markerade dagar i veckan är hög tillgänglighet, 3–4 medel, 0–2 låg.
const getLevel = (days: number): Level => {
  if (days >= 5) return 'high';
  if (days >= 3) return 'medium';
  return 'low';
};

const levelColors: Record<Level, FlattenSimpleInterpolation> = {
  high: css`
    background: rgba(106, 189, 100, 0.25);
    border-color: #6abd64;
    color: #2f6b2b;
  `,
  medium: css`
    background: rgba(255, 191, 0, 0.2);
    border-color: ${amber};
    color: #7a5a00;
  `,
  low: css`
    background: ${lightGrey};
    border-color: rgb(190, 190, 190);
    color: rgb(90, 90, 90);
  `,
};

const Pill = styled.span<{ $level: Level }>`
  display: inline-flex;
  align-items: center;
  padding: 0 6px;
  border: 1px solid;
  border-radius: 10px;
  font-size: 0.85em;
  font-weight: normal;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  line-height: 1.4;
  ${({ $level }) => levelColors[$level]}
`;

interface Props {
  /** Markerat tillgängliga dagar mån–sön. */
  days: number;
  /** "5 av 7 dagar tillgänglig" i stället för "5/7". */
  long?: boolean;
  title?: string;
}

const AvailableDaysPill: React.FC<Props> = ({ days, long, title }) => (
  <Pill $level={getLevel(days)} title={title}>
    {long ? `${days} av 7 dagar tillgänglig` : `${days}/7`}
  </Pill>
);

export default AvailableDaysPill;
